// This library stores its data in "pages" property of Redux state.
export const REDUCER_NAME = 'pages'

export const PAGE_STATE_REDUCER_NAME_PREFIX = '_pageState_'